import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
export type AllStockTakeLotFields_StockTakeLotAddition_Fragment = { readonly __typename?: 'StockTakeLotAddition', readonly id: string, readonly name: string, readonly expiryDate: string, readonly lastStockTakeAt?: string | null, readonly additionReviewQuantity: number, readonly additionQuantityDifference: number, readonly additionLot?: { readonly __typename?: 'StockTakePartialLot', readonly sku: { readonly __typename?: 'Sku', readonly id: string, readonly externalReferences: ReadonlyArray<{ readonly __typename?: 'SkuExternalReference', readonly origin: string }> } } | null };

export type AllStockTakeLotFields_StockTakeLotUpdate_Fragment = { readonly __typename?: 'StockTakeLotUpdate', readonly id: string, readonly name: string, readonly reviewedQuantity?: number | null, readonly initialQuantity: number, readonly quantityDifference: number, readonly lastStockTakeAt?: string | null, readonly lot: { readonly __typename?: 'StockTakePartialLot', readonly expiryDate: string, readonly sku: { readonly __typename?: 'Sku', readonly id: string, readonly externalReferences: ReadonlyArray<{ readonly __typename?: 'SkuExternalReference', readonly origin: string }> } } };

export type AllStockTakeLotFieldsFragment = AllStockTakeLotFields_StockTakeLotAddition_Fragment | AllStockTakeLotFields_StockTakeLotUpdate_Fragment;

export const AllStockTakeLotFieldsFragmentDoc = gql`
    fragment AllStockTakeLotFields on StockTakeLot {
  ... on StockTakeLotUpdate {
    id
    name
    lot {
      expiryDate
      sku {
        id
        externalReferences {
          origin
        }
      }
    }
    reviewedQuantity
    initialQuantity
    quantityDifference
    lastStockTakeAt
  }
  ... on StockTakeLotAddition {
    id
    name
    expiryDate
    additionReviewQuantity: reviewedQuantity
    additionQuantityDifference: quantityDifference
    lastStockTakeAt
    additionLot: lot {
      sku {
        id
        externalReferences {
          origin
        }
      }
    }
  }
}
    `;